export default function Logo({ chip = false }) {
    return (
        <span className="inline-flex items-center select-none" aria-label="Solino Pro — accueil">
            <img
                src="/logo-solinopro.png"
                alt="Solino Pro — artisan BTP peinture & revêtement de sol"
                className={`h-12 w-auto ${chip ? "bg-ivory rounded-lg p-1.5" : ""}`}
                width="132"
                height="120"
            />
        </span>
    );
}
